import React from "react";
import "./css/AboutUs.css";
import pictureOne from "./assets/picOne.png";

const WTSPSInquiryPoint = () => {
  return (
    <div className="about-us">
      {/* === Header Section === */}
      <section className="about-header inquiry-header">
        <div className="overlay">
          <h1 className="page-title">WT/SPS National Inquiry Point</h1>
          <p className="subtitle">
            Facilitating trade, technical standards, and sanitary & phytosanitary measures in Malawi.
          </p>
        </div>
      </section>

      {/* === Introduction Section === */}
      <section className="intro-section">
        <div className="intro-card">
          <h2>About the WT/SPS National Inquiry Point</h2>
          <p>
            The Malawi Bureau of Standards (MBS) serves as the National Inquiry Point for the World Trade 
            Organization (WTO) Agreements on Technical Barriers to Trade (TBT) and Sanitary and Phytosanitary 
            (SPS) Measures. This function ensures that Malawi’s stakeholders are informed about international 
            regulations and standards affecting trade.
          </p>
        </div>

        <div className="intro-card">
          <h2>Our Role</h2>
          <p>
            As the WT/SPS Inquiry Point, MBS provides access to notifications, guidance, and information 
            related to technical regulations, standards, and conformity assessment procedures. This supports 
            Malawi’s compliance with WTO commitments and promotes safe, quality products in international trade.
          </p>
        </div>
      </section>

      {/* === Core Functions Section === */}
      <section className="functions-section">
        <h2>Functions of the WT/SPS National Inquiry Point</h2>
        <ul>
          <li>Disseminating WTO TBT/SPS notifications to relevant stakeholders in Malawi.</li>
          <li>Providing guidance on international technical regulations and standards.</li>
          <li>Facilitating comments and feedback on proposed international measures.</li>
          <li>Promoting awareness of trade-related technical requirements.</li>
          <li>Supporting Malawi’s compliance with international trade obligations.</li>
        </ul>
      </section>

      {/* === Background and Mandate Section === */}
      <section className="background-section">
        <div className="text-content">
          <h2>Background</h2>
          <p>
            The WTO requires member countries to establish National Inquiry Points for TBT and SPS agreements. 
            MBS was designated to coordinate and provide access to information, notifications, and guidance on 
            international technical regulations, ensuring Malawi meets its obligations in global trade.
          </p>

          <h2>Mandate</h2>
          <p>
            To act as the central point for WTO TBT/SPS information, facilitating access to relevant notifications, 
            coordinating stakeholder responses, and promoting compliance with international standards to 
            enhance trade efficiency and safety.
          </p>
        </div>

        <div className="image-content">
          <img src={pictureOne} alt="WT/SPS Inquiry Point Illustration" />
        </div>
      </section>

      {/* === Benefits Section === */}
      <section className="benefits-section">
        <h2>Benefits of the WT/SPS National Inquiry Point</h2>
        <ul>
          <li>Ensures Malawi’s stakeholders have timely access to international technical and sanitary regulations.</li>
          <li>Supports trade facilitation by reducing technical barriers.</li>
          <li>Promotes the adoption of safe and compliant products in local and international markets.</li>
          <li>Strengthens Malawi’s credibility and participation in global trade agreements.</li>
          <li>Encourages proactive engagement with international standardization processes.</li>
        </ul>
      </section>
    </div>
  );
};

export default WTSPSInquiryPoint;
